import React, { useReducer, useEffect } from 'react';
import PropTypes from 'prop-types';
import UpArrow from '@material-ui/icons/KeyboardArrowUp';
import DownArrow from '@material-ui/icons/KeyboardArrowDown';
import Collapse from '@material-ui/core/Collapse';

const initialState = {
  isOpen: false
};

const ACTION_TYPES = {
  OPEN: 'OPEN',
  CLOSE: 'CLOSE'
};

const ACTIONS = {
  open: () => ({ type: ACTION_TYPES.OPEN }),
  close: () => ({ type: ACTION_TYPES.CLOSE })
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.OPEN: { return { ...state, isOpen: true }; }
    case ACTION_TYPES.CLOSE: { return { ...state, isOpen: false }; }
    default: {
      throw Error('CollapsableSection reducer should never hit default');
    }
  }
};

const containerStyle = {
  marginBottom: '0.2em'
};

const collapsedSectionStyle = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'none',
  justifyContent: 'space-between',
  backgroundColor: '#303f9f',
  height: '33px'
};

const titleStyle = {
  padding: '0.35em',
  // fontWeight: 'bold',
  color: '#fff'
};

const CollapsableSection = ({
  title,
  children,
  titleCount,
  shouldStartOpened = false
}) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    if (shouldStartOpened === true) dispatch(ACTIONS.open());
  }, []);

  const formatTitleCount = count => {
    if (count === null || count === undefined) return null;

    return ` (${count})`;
  };

  return (
    <div style={containerStyle}>
      {/* collapsed section */}
      <div style={collapsedSectionStyle}>
        {/* title */}
        <div style={titleStyle}>
          <span>{title}{formatTitleCount(titleCount)}</span>
        </div>

        {/* icon button to open/close */}
        <div>
          <button
            onClick={() =>
              state.isOpen === true
                ? dispatch(ACTIONS.close())
                : dispatch(ACTIONS.open())
            }
          >
            {
              state.isOpen === true
                ? <UpArrow />
                : <DownArrow />
            }
          </button>
        </div>
      </div>

      {/* expanded content */}
      {/* <div style={{ display: state.isOpen === true ? 'block' : 'none' }}> */}
      <Collapse in={state.isOpen === true}>
        {
          children
        }
      </Collapse>
      {/* </div> */}
    </div>
  );
};

CollapsableSection.propTypes = {
  title: PropTypes.string.isRequired,
  shouldStartOpened: PropTypes.bool.isRequired
};

export default CollapsableSection;
